import React from 'react'

const Error = () => {
  return (
    <div className='bg-gray-100 flex flex-col items-center justify-center min-h-screen m-auto'>
      <div className='bg-white shadow-md rounded-lg p-8 max-w-sm text-center'>
        <img src="https://img.freepik.com/free-vector/404-liquid-error_114341-59.jpg?size=626&ext=jpg" alt="Error" className='mb-4' />
      </div>
    </div>
  )
    
}

export default Error